const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroImageLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.562,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.574,
    y: 391.397,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.685,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.807,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.57,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.312,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.439,
    y: 80.682,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 595.4362 373.3031)",
    style: {
      fill: "#E6E6E6"
    },
    width: 276.558,
    height: 211.939
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M143.717,75.672h301.777c0.804,0,1.456,0.652,1.456,1.456l0,0c0,0.804-0.652,1.456-1.456,1.456 H143.717c-0.804,0-1.456-0.652-1.456-1.456l0,0C142.261,76.324,142.913,75.672,143.717,75.672z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.214,
    y: 80.682,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 586.3023 373.3031)",
    style: {
      fill: "#EBEBEB"
    },
    width: 279.874,
    height: 211.939
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.897,
    y: 55.43,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 479.8028 -106.4996)",
    style: {
      fill: "#FAFAFA"
    },
    width: 194.509,
    height: 262.444
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "370.465,283.905 309.916,89.397 274.688,89.397 335.237,283.905  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "310.679,283.905 250.13,89.397 236.396,89.397 296.945,283.905  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.228,
    y: 186.098,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 349.1341 24.169)",
    style: {
      fill: "#E6E6E6"
    },
    width: 194.509,
    height: 1.107
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.218,
    y: 73.065,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 851.4885 351.175)",
    style: {
      fill: "#F0F0F0"
    },
    width: 27.053,
    height: 205.045
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.679,
    y: 73.065,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 824.4352 351.175)",
    style: {
      fill: "#E6E6E6"
    },
    width: 21.077,
    height: 205.045
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.164,
    y: 73.065,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 797.3819 351.175)",
    style: {
      fill: "#F0F0F0"
    },
    width: 27.053,
    height: 205.045
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.626,
    y: 73.065,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 770.3287 351.175)",
    style: {
      fill: "#E6E6E6"
    },
    width: 21.077,
    height: 205.045
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 73.065,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 743.2754 351.175)",
    style: {
      fill: "#F0F0F0"
    },
    width: 27.053,
    height: 205.045
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.511,
    y: 73.066,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 343.6662 351.1768)",
    style: {
      fill: "#F0F0F0"
    },
    width: 8.644,
    height: 205.045
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.144,
    y: 73.066,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 335.0227 351.1768)",
    style: {
      fill: "#E6E6E6"
    },
    width: 6.734,
    height: 205.045
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.868,
    y: 73.066,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 326.3791 351.1768)",
    style: {
      fill: "#F0F0F0"
    },
    width: 8.644,
    height: 205.045
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.501,
    y: 73.066,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 317.7355 351.1768)",
    style: {
      fill: "#E6E6E6"
    },
    width: 6.734,
    height: 205.045
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.224,
    y: 73.066,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 309.092 351.1768)",
    style: {
      fill: "#F0F0F0"
    },
    width: 8.644,
    height: 205.045
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 75.381,
    y: 107.711,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 212.726 293.3128)",
    style: {
      fill: "#F0F0F0"
    },
    width: 61.965,
    height: 77.891
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.702,
    y: 107.711,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 196.6729 293.3128)",
    style: {
      fill: "#F5F5F5"
    },
    width: 73.27,
    height: 77.891
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.529,
    y: 116.16,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -48.32 244.993)",
    style: {
      fill: "#FFFFFF"
    },
    width: 65.614,
    height: 60.993
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 406.816,
    y: 311.727,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 825.8851 689.1337)",
    style: {
      fill: "#F0F0F0"
    },
    width: 12.252,
    height: 65.679
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.528,
    y: 377.406,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 643.5306 760.9102)",
    style: {
      fill: "#F0F0F0"
    },
    width: 184.475,
    height: 6.098
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.462,
    y: 311.727,
    style: {
      fill: "#FAFAFA"
    },
    width: 182.355,
    height: 65.679
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.835,
    y: 319.717,
    style: {
      fill: "#F0F0F0"
    },
    width: 161.608,
    height: 20.21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.835,
    y: 345.684,
    style: {
      fill: "#F0F0F0"
    },
    width: 161.608,
    height: 20.21
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M270.212,321.539h90.853c1.014,0,1.845-0.83,1.845-1.844v-0.639c0-1.015-0.83-1.845-1.845-1.845 h-90.853c-1.014,0-1.845,0.83-1.845,1.845v0.639C268.368,320.709,269.198,321.539,270.212,321.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M270.212,347.505h90.853c1.014,0,1.845-0.83,1.845-1.845v-0.639c0-1.015-0.83-1.845-1.845-1.845 h-90.853c-1.014,0-1.845,0.83-1.845,1.845v0.639C268.368,346.675,269.198,347.505,270.212,347.505z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 220.946,
    y: 305.838,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 627.7623 617.5657)",
    style: {
      fill: "#F0F0F0"
    },
    width: 185.87,
    height: 5.889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.816,
    y: 305.838,
    style: {
      fill: "#E6E6E6"
    },
    width: 15.94,
    height: 5.889
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M100.274,352.559h5.936c-0.044-5.31,0.015-32.432,0.418-63.297 c0.367-28.609,1.027-40.073,1.585-44.449l-4.776,8.321c-1.658,6.503-4.418,17.637-4.653,24.474 C98.036,299.13,100.949,329.974,100.274,352.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M95.763,249.194c-7.917-15.475-23.724-23.55-39.879-31.152 c-6.343-2.985,11.459,34.041,24.402,50.826c10.054,13.039,19.773,12.747,22.693,25.636 C103.538,279.543,102.585,262.527,95.763,249.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M110.79,275.371c7.015-9.147,18.564-11.493,30.296-13.437c4.606-0.763-11.408,21.36-21.959,30.376 c-8.196,7.004-14.731,4.781-18.092,13.163C102.269,294.922,104.746,283.253,110.79,275.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M96.665,292.862c-5.451-7.108-14.425-8.931-23.542-10.441 c-3.579-0.593,8.864,16.598,17.063,23.603c6.369,5.442,11.446,3.715,14.058,10.228 C103.286,308.053,101.362,298.986,96.665,292.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M107.884,320.723c3.755-4.803,9.876-5.985,16.093-6.953c2.441-0.38-6.138,11.241-11.764,15.957 c-4.37,3.663-7.816,2.453-9.635,6.87C103.282,331.022,104.649,324.861,107.884,320.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M104.343,249.773c4.377-15.172,21.662-38.825,39.446-43.688 c6.982-1.909-18.113,36.482-26.709,55.589c-6.692,14.876-12.984,23.905-13.873,34.564 C98.767,282.838,99.966,264.945,104.343,249.773z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M105.816,382.398L105.816,382.398c-12.317,0-22.495-1.825-23.202-14.122l-2.053-21.009h50.509 l-2.053,21.009C128.311,380.573,118.133,382.398,105.816,382.398z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "134.341,351.55 77.291,351.55 75.657,339.918 135.975,339.918  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M213.006,302.446c24.239-0.46,47.601,12.673,71.185,16.818c23.563,4.141,49.067,4.676,72.354-0.55 C413.53,305.925,451.03,263.143,439,216.349c-9.566-37.208,20.998-85.914-8.444-122.243 c-29.816-36.79-66.658-45.218-110.948-48.271c-40.931-2.822-111.845-6.289-136.635,32.221 c-28.292,43.95,39.426,95.049-15.193,122.621c-43.635,22.027-90.954,60.66-65.702,111.226 C128.852,365.518,172.992,303.205,213.006,302.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M213.006,302.446c24.239-0.46,47.601,12.673,71.185,16.818 c23.563,4.141,49.067,4.676,72.354-0.55C413.53,305.925,451.03,263.143,439,216.349c-9.566-37.208,20.998-85.914-8.444-122.243 c-29.816-36.79-66.658-45.218-110.948-48.271c-40.931-2.822-111.845-6.289-136.635,32.221 c-28.292,43.95,39.426,95.049-15.193,122.621c-43.635,22.027-90.954,60.66-65.702,111.226 C128.852,365.518,172.992,303.205,213.006,302.446z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__348_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Technology"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M379.242,138.433c-0.047,0-0.096-0.007-0.144-0.021c-0.265-0.08-0.415-0.358-0.335-0.622 c8.95-29.814,2.519-56.052-17.203-70.187c-18.078-12.956-42.74-12.749-61.37,0.515c-52.709,37.529-93.012,44.806-134.76,24.333 c-0.248-0.122-0.35-0.421-0.229-0.669c0.122-0.248,0.422-0.351,0.669-0.229c41.374,20.287,81.371,13.036,133.74-24.25 c18.977-13.512,44.107-13.719,62.532-0.513c20.085,14.395,26.656,41.044,17.578,71.286 C379.656,138.294,379.457,138.433,379.242,138.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M346.146,291.671c-9.835,0-19.673-2.356-29.054-7.074c-37.04-18.624-65.778-17.784-76.873,2.247 c-0.134,0.242-0.439,0.327-0.68,0.195c-0.242-0.134-0.329-0.439-0.195-0.68c11.387-20.558,40.619-21.552,78.198-2.655 c18.76,9.433,39.379,9.277,58.059-0.436c22.085-11.486,38.666-34.655,42.242-59.024c0.04-0.273,0.289-0.466,0.567-0.422 c0.273,0.04,0.462,0.294,0.422,0.567c-3.621,24.676-20.409,48.135-42.77,59.765C366.43,289.164,356.289,291.671,346.146,291.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M408.204,233.253c-0.057,0-0.114-0.01-0.171-0.03c-0.259-0.094-0.394-0.381-0.299-0.641 c10.727-29.494-4.585-41.275-19.392-52.668c-14.038-10.801-28.553-21.971-20.283-47.943c0.084-0.263,0.364-0.408,0.628-0.325 c0.263,0.084,0.408,0.365,0.325,0.628c-8.058,25.304,5.542,35.768,19.939,46.847c15.092,11.613,30.699,23.621,19.722,53.803 C408.6,233.127,408.409,233.253,408.204,233.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#407BFF"
    },
    d: "M398.732,238.057c-7.313,24.852-35.189,43.895-60.407,37.963 c-30.584-7.194-46.7-33.252-41.284-58.586c5.416-25.333,33.648-12.315,58.98-17.741 C388.561,192.724,406.044,213.205,398.732,238.057z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M253.186,95.259c0.21,1.891-1.153,3.594-3.044,3.803c-1.891,0.21-3.593-1.153-3.803-3.044 c-0.21-1.891,1.153-3.593,3.044-3.803C251.274,92.005,252.977,93.368,253.186,95.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M249.76,99.583c-1.982,0-3.694-1.495-3.918-3.51c-0.239-2.162,1.324-4.115,3.486-4.355 c2.163-0.241,4.116,1.324,4.355,3.486l0,0c0.239,2.162-1.324,4.115-3.486,4.355C250.051,99.575,249.905,99.583,249.76,99.583z  M249.765,92.694c-0.108,0-0.217,0.006-0.326,0.018c-1.614,0.179-2.781,1.638-2.602,3.251c0.179,1.614,1.645,2.784,3.251,2.602 c1.614-0.179,2.781-1.638,2.602-3.251l0,0C252.522,93.81,251.244,92.694,249.765,92.694z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M371.96,131.743c0.21,1.891-1.153,3.593-3.044,3.803c-1.891,0.21-3.593-1.153-3.803-3.044 c-0.21-1.891,1.153-3.593,3.044-3.803C370.047,128.489,371.75,129.852,371.96,131.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M368.528,136.067c-0.892,0-1.75-0.3-2.457-0.865c-0.823-0.658-1.339-1.598-1.456-2.645 c-0.116-1.047,0.182-2.077,0.841-2.9c0.658-0.822,1.598-1.339,2.645-1.456c1.049-0.113,2.077,0.182,2.899,0.841 c0.823,0.658,1.34,1.597,1.456,2.645l0,0c0.116,1.047-0.183,2.077-0.841,2.899c-0.659,0.823-1.598,1.34-2.645,1.456 C368.823,136.059,368.675,136.067,368.528,136.067z M368.542,129.178c-0.11,0-0.22,0.006-0.331,0.019 c-0.782,0.086-1.483,0.472-1.974,1.086c-0.492,0.614-0.714,1.383-0.627,2.165c0.086,0.782,0.472,1.483,1.086,1.974 c0.614,0.492,1.383,0.714,2.164,0.627c0.782-0.086,1.483-0.472,1.975-1.086c0.491-0.614,0.714-1.383,0.627-2.165l0,0 c-0.087-0.782-0.473-1.483-1.087-1.974C369.849,129.402,369.208,129.178,368.542,129.178z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M406.352,260.022c0.21,1.891-1.153,3.594-3.044,3.803c-1.891,0.21-3.594-1.153-3.803-3.044 c-0.21-1.891,1.153-3.593,3.044-3.803C404.44,256.769,406.143,258.131,406.352,260.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M402.921,264.347c-0.892,0-1.751-0.3-2.457-0.865c-0.823-0.658-1.34-1.598-1.456-2.645 c-0.239-2.162,1.324-4.115,3.486-4.355c1.046-0.116,2.077,0.182,2.899,0.841c0.823,0.658,1.34,1.598,1.456,2.646l0,0 c0.239,2.161-1.324,4.114-3.486,4.354C403.216,264.339,403.068,264.347,402.921,264.347z M402.935,257.457 c-0.109,0-0.22,0.006-0.331,0.019c-1.614,0.179-2.781,1.638-2.602,3.251c0.179,1.614,1.642,2.786,3.251,2.602 c1.614-0.179,2.781-1.638,2.602-3.251l0,0c-0.087-0.781-0.473-1.483-1.087-1.975C404.242,257.681,403.6,257.457,402.935,257.457z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M371.074,259.52c-0.882,1.685-2.963,2.337-4.649,1.455c-1.685-0.882-2.337-2.963-1.455-4.649 c0.882-1.686,2.963-2.337,4.649-1.455C371.305,255.753,371.956,257.835,371.074,259.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M368.016,261.866c-0.616,0-1.24-0.144-1.823-0.448c-0.934-0.488-1.621-1.312-1.936-2.316 c-0.314-1.006-0.219-2.074,0.27-3.007c1.008-1.928,3.396-2.676,5.324-1.667c1.927,1.009,2.674,3.397,1.665,5.324l0,0 C370.813,261.097,369.438,261.866,368.016,261.866z M368.027,254.979c-1.062,0-2.088,0.575-2.614,1.579 c-0.365,0.697-0.436,1.494-0.201,2.245c0.235,0.75,0.748,1.364,1.445,1.729c1.438,0.752,3.221,0.194,3.974-1.242l0,0 c0.752-1.439,0.195-3.223-1.244-3.975C368.953,255.087,368.487,254.979,368.027,254.979z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M380.913,245.866c-0.091,0-0.181-0.033-0.251-0.097l-20.185-18.223 c-0.153-0.139-0.166-0.376-0.027-0.53c0.139-0.155,0.377-0.167,0.53-0.027l19.651,17.741l2.708-21.409 c0.026-0.206,0.215-0.354,0.419-0.325c0.206,0.026,0.351,0.214,0.325,0.419l-2.799,22.122c-0.018,0.139-0.111,0.256-0.242,0.305 C381,245.858,380.957,245.866,380.913,245.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M368.022,258.298c-0.098,0-0.196-0.038-0.27-0.114c-0.144-0.149-0.139-0.387,0.01-0.53 l12.89-12.432c0.149-0.144,0.386-0.14,0.53,0.009c0.144,0.149,0.139,0.387-0.01,0.53l-12.89,12.432 C368.21,258.263,368.116,258.298,368.022,258.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M363.386,228.659c-0.768,1.468-2.581,2.035-4.049,1.267c-1.468-0.768-2.035-2.581-1.267-4.049 c0.768-1.468,2.581-2.035,4.049-1.267C363.587,225.379,364.154,227.191,363.386,228.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M385.591,224.354c-0.543,1.038-1.825,1.439-2.863,0.896c-1.038-0.543-1.439-1.825-0.896-2.863 c0.543-1.038,1.825-1.439,2.863-0.896C385.733,222.034,386.134,223.316,385.591,224.354z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M264.347,181.938c0.046-1.902,1.625-3.406,3.526-3.36c1.902,0.046,3.406,1.625,3.36,3.526 c-0.046,1.902-1.625,3.406-3.526,3.36C265.805,185.419,264.301,183.84,264.347,181.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M267.791,185.965c-0.032,0-0.064-0.001-0.097-0.001c-2.174-0.053-3.9-1.864-3.848-4.039 c0.025-1.053,0.46-2.034,1.223-2.76c0.762-0.727,1.745-1.108,2.816-1.088c2.174,0.053,3.9,1.864,3.848,4.039 C271.682,184.258,269.923,185.965,267.791,185.965z M267.789,179.077c-0.759,0-1.478,0.287-2.03,0.813 c-0.569,0.542-0.893,1.274-0.912,2.061c-0.04,1.623,1.25,2.975,2.873,3.014c0.789,0.021,1.533-0.269,2.102-0.812 c0.569-0.542,0.893-1.274,0.912-2.061c0.019-0.786-0.269-1.533-0.811-2.102c-0.543-0.569-1.274-0.893-2.061-0.912 C267.837,179.077,267.813,179.077,267.789,179.077z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M255.075,181.989c-0.189,0-0.351-0.142-0.372-0.333l-1.153-10.399 c-0.005-0.048-0.001-0.097,0.012-0.144l3.956-13.901c0.057-0.199,0.264-0.313,0.463-0.258c0.199,0.057,0.315,0.264,0.258,0.463 l-3.936,13.831l1.145,10.326c0.023,0.206-0.126,0.392-0.331,0.414C255.103,181.988,255.089,181.989,255.075,181.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M267.79,182.396c-0.081,0-0.162-0.026-0.23-0.079l-13.868-10.806 c-0.164-0.127-0.193-0.363-0.065-0.526c0.127-0.163,0.363-0.192,0.526-0.066l13.868,10.806c0.164,0.127,0.193,0.363,0.065,0.526 C268.012,182.346,267.902,182.396,267.79,182.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M254.879,157.241c0.04-1.656,1.415-2.967,3.071-2.927c1.656,0.04,2.967,1.415,2.927,3.072 c-0.04,1.656-1.415,2.967-3.072,2.927C256.149,160.273,254.839,158.897,254.879,157.241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M252.955,181.562c0.028-1.171,1.001-2.098,2.172-2.07c1.171,0.028,2.098,1.001,2.07,2.172 c-0.028,1.171-1.001,2.098-2.172,2.07C253.853,183.706,252.927,182.734,252.955,181.562z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#407BFF"
    },
    d: "M359.033,114.875c5.024-17.674-5.816-36.102-24.046-40.081 c-16.082-3.511-32.496,6.084-37.374,21.806c-3.102,9.996-1.073,20.3,4.54,28.156c1.11,1.554,1.91,3.307,2.247,5.187l0,0 c0.832,4.643,4.237,8.405,8.774,9.695l10.192,2.897c4.537,1.29,9.412-0.119,12.562-3.63l0.006-0.007 c1.261-1.406,2.84-2.476,4.583-3.202C349.222,132.069,356.253,124.653,359.033,114.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M324.647,150.46l-16.734-4.757c-1.26-0.358-1.998-1.682-1.64-2.943l0,0 c0.358-1.26,1.682-1.998,2.943-1.64l16.734,4.757c1.26,0.358,1.998,1.682,1.64,2.943l0,0 C327.232,150.08,325.908,150.818,324.647,150.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M321.13,156.65l-13.482-3.832c-1.26-0.358-1.998-1.682-1.64-2.943l0,0 c0.358-1.26,1.682-1.998,2.943-1.64l13.482,3.832c1.26,0.358,1.998,1.683,1.64,2.943l0,0 C323.715,156.27,322.391,157.008,321.13,156.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M323.365,143.035c-0.027,0-0.055-0.002-0.083-0.007c-0.272-0.045-0.456-0.303-0.411-0.575 c0.163-0.983,2.771-16.365,7.733-27.949c-1.382-0.259-2.872-0.609-4.476-1.065c-1.604-0.456-3.055-0.942-4.366-1.449 c-1.874,12.462-7.748,26.915-8.126,27.837c-0.105,0.256-0.396,0.379-0.652,0.272c-0.255-0.104-0.377-0.396-0.273-0.652 c0.093-0.227,6.211-15.274,8.091-27.843c-9.711-4.041-11.156-9.246-11.286-11.52c-0.154-2.701,1.273-5.146,3.553-6.087 c2.28-0.941,4.812-0.183,6.77,2.028c2.64,2.978,2.909,8.645,2.068,14.942c1.336,0.528,2.829,1.035,4.495,1.508 c1.666,0.474,3.203,0.828,4.617,1.081c2.598-5.796,5.808-10.477,9.619-11.62c2.828-0.847,5.38-0.163,6.824,1.837 c1.444,1.999,1.371,4.831-0.181,7.046c-1.307,1.865-5.274,5.53-15.658,3.86c-5.012,11.679-7.725,27.694-7.765,27.936 C323.817,142.861,323.605,143.035,323.365,143.035z M332.041,113.728c9.951,1.506,13.491-2.155,14.421-3.48 c1.308-1.867,1.383-4.232,0.188-5.886c-1.183-1.638-3.324-2.186-5.726-1.465C337.469,103.933,334.495,108.273,332.041,113.728z  M315.031,94.607c-0.536,0-1.067,0.104-1.581,0.315c-1.886,0.778-3.066,2.83-2.936,5.105c0.093,1.617,1.177,6.594,10.434,10.546 c0.783-5.93,0.537-11.185-1.857-13.885C317.884,95.329,316.444,94.607,315.031,94.607z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M353.665,168.076l7.528,17.03c0.423,0.957-0.014,2.087-0.971,2.51l0,0 c-0.957,0.423-2.087-0.014-2.51-0.971l-7.528-17.03c-0.423-0.957,0.014-2.087,0.971-2.51l0,0 C352.112,166.682,353.242,167.119,353.665,168.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M304.548,266.16l25.689-1.797c0.634-0.044,1.19,0.438,1.234,1.073l0,0 c0.044,0.634-0.438,1.189-1.073,1.234l-25.689,1.797c-0.634,0.044-1.19-0.438-1.234-1.073l0,0 C303.431,266.759,303.913,266.204,304.548,266.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M260.103,125.194l24.783,6.996c0.612,0.173,0.971,0.815,0.798,1.427l0,0 c-0.173,0.612-0.815,0.971-1.427,0.799l-24.783-6.996c-0.612-0.173-0.971-0.815-0.798-1.427l0,0 C258.849,125.381,259.491,125.022,260.103,125.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M241.614,110.994l-13.011,8.294c-0.732,0.466-1.712,0.249-2.178-0.482l0,0 c-0.466-0.731-0.249-1.711,0.482-2.178l13.011-8.294c0.731-0.466,1.712-0.249,2.178,0.482l0,0 C242.563,109.548,242.346,110.528,241.614,110.994z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M337.389,211.38c0.343-0.782,0.099-1.834-0.545-2.35l-30.225-24.19 c-0.644-0.516-1.445-0.299-1.788,0.483l-9.634,21.961l-19.242,14.462c-0.681,0.512-0.711,1.344-0.067,1.86l30.225,24.19 c0.644,0.516,1.718,0.518,2.4,0.007l19.242-14.462L337.389,211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M326.83,232.6l-32.558-26.057l9.634-21.961c0.343-0.782,1.143-0.998,1.788-0.483l30.225,24.19 c0.644,0.516,0.888,1.568,0.545,2.35L326.83,232.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M326.083,229.73c-0.056,0-0.111-0.019-0.156-0.055l-29.213-23.38h0.001 c-0.184-0.146-0.264-0.519-0.162-0.752l8.492-19.357c0.031-0.071,0.094-0.124,0.169-0.142c0.075-0.018,0.155-0.001,0.216,0.047 l29.212,23.38c0.184,0.147,0.265,0.52,0.162,0.752l-8.492,19.357c-0.031,0.071-0.094,0.124-0.169,0.142 C326.123,229.727,326.103,229.73,326.083,229.73z M297.038,205.913l28.948,23.167l8.361-19.059 c0.012-0.035-0.006-0.14-0.031-0.174l-28.943-23.163l-8.361,19.059C296.999,205.777,297.015,205.874,297.038,205.913z  M297.041,205.919L297.041,205.919L297.041,205.919L297.041,205.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M326.83,232.6l-32.558-26.057l-19.242,14.462c-0.681,0.512-0.711,1.345-0.067,1.86l30.225,24.19 c0.644,0.516,1.719,0.519,2.399,0.007L326.83,232.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M285.004,217.033l7.804-5.865c0.737-0.554,1.899-0.55,2.596,0.007l25.491,20.401 c0.697,0.558,0.665,1.459-0.072,2.013l-7.804,5.865c-0.737,0.554-1.899,0.55-2.596-0.007l-25.491-20.401 C284.235,218.488,284.267,217.587,285.004,217.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M286.404,228.71l3.933-2.956c0.332-0.25,0.856-0.248,1.17,0.003l10.473,8.381 c0.314,0.252,0.3,0.658-0.033,0.907l-3.933,2.956c-0.332,0.25-0.856,0.248-1.17-0.003l-10.473-8.381 C286.057,229.366,286.072,228.96,286.404,228.71z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M308.934,171.144c-0.165,0-0.317-0.11-0.362-0.278c-0.054-0.2,0.065-0.406,0.265-0.459 l17.205-4.624c0.202-0.054,0.406,0.066,0.46,0.265c0.054,0.2-0.065,0.406-0.265,0.459l-17.205,4.624 C308.998,171.14,308.965,171.144,308.934,171.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M325.029,166.772c-0.347-0.613-0.131-1.39,0.482-1.737c0.613-0.347,1.39-0.131,1.737,0.482 c0.347,0.613,0.131,1.39-0.482,1.737C326.153,167.6,325.375,167.385,325.029,166.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M307.824,171.396c-0.346-0.613-0.131-1.39,0.482-1.737c0.613-0.347,1.39-0.131,1.737,0.482 c0.346,0.613,0.131,1.39-0.482,1.737C308.948,172.225,308.171,172.009,307.824,171.396z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8957 -0.4447 0.4447 0.8957 -70.0521 100.0685)",
    style: {
      opacity: 0.3,
      fill: "#407BFF"
    },
    cx: 178.235,
    cy: 199.326,
    rx: 47.696,
    ry: 93.696
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B55B52"
    },
    points: "157.724,408.656 165.121,408.54 166.821,391.378 159.423,391.494  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B55B52"
    },
    points: "107.996,395.154 115.048,397.389 123.001,381.937 115.949,379.701  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "166.819,391.383 165.944,400.229 158.544,400.345 159.418,391.499  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "115.945,379.705 123,381.941 118.897,389.905 111.842,387.669  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M168.689,398.477l-12.526,0.191c0,0,4.942-48.668,6.566-71.665 c0.493-6.996,0.264-16.891-0.321-27.537c-0.744-13.414-1.231-18.788-2.239-35.75c-0.719-12.094-1.599-19.926-1.599-19.926 l25.927,2.13c0,0,1.02,58.713-1.921,81.101C179.521,350.3,168.689,398.477,168.689,398.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M165.702,260.048c3.247,12.087,0.095,39.113-2.95,46.462c-0.096-2.296-0.213-4.649-0.343-7.041 c-0.747-13.42-1.235-18.789-2.244-35.75c-0.015-0.336-0.041-0.664-0.057-0.991C161.867,261.519,163.757,260.548,165.702,260.048z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M170.508,244.771c0,0-11.992,60.321-17.987,81.153c-6.565,22.813-29.832,63.389-29.832,63.389 l-12.917-4.094c0,0,14.88-34.348,20.372-56.833c6.256-25.612,14.916-85.703,14.916-85.703L170.508,244.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M116.554,396.898l-8.164-3.834c-0.274-0.129-0.6-0.05-0.785,0.19l-4.118,5.331 c-0.427,0.553-0.216,1.365,0.421,1.651c2.648,1.188,4.637,1.935,7.946,3.488c2.035,0.956,6.757,3.379,9.567,4.699 c2.749,1.291,4.435-1.227,3.451-2.079c-4.411-3.819-6.469-6.264-7.424-8.524C117.275,397.412,116.954,397.086,116.554,396.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M165.056,407.684l-8.078,0.127c-0.302,0.005-0.561,0.219-0.622,0.515l-1.358,6.598 c-0.141,0.684,0.387,1.322,1.085,1.299c2.913-0.095,7.122-0.332,10.784-0.389c4.283-0.067,4.773,0.108,9.795,0.03 c3.037-0.048,3.832-3.131,2.556-3.389c-5.807-1.175-7.322-1.237-12.371-4.242C166.298,407.906,165.694,407.674,165.056,407.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M151.742,177.429c9.046-0.64,19.332-0.381,27.86,0.993c5.656,0.911,9.936,5.592,10.303,11.309 c0.625,9.751,0.405,28.905-4.184,64.851c-5.7,2.494-30.583,0.083-42.797-3.757c0.653-4.111,4.529-37.262,1.688-64.97 C144.169,181.544,147.418,177.735,151.742,177.429z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M153.785,190.712l-1.512,3.113c-0.508,1.068-0.996,2.15-1.47,3.237 c-0.959,2.17-1.852,4.363-2.703,6.56c-0.837,2.203-1.577,4.418-2.252,6.633c-0.638,2.221-1.172,4.434-1.563,6.635l-0.997-3.409 c0.727,0.972,1.781,1.87,3.312,2.495c1.497,0.64,3.325,1.058,5.248,1.267c1.931,0.216,3.966,0.254,6.029,0.169 c2.046-0.056,4.209-0.294,6.181-0.557l0.15-0.02c1.362-0.182,2.614,0.775,2.795,2.137c0.151,1.132-0.487,2.188-1.489,2.617 c-1.165,0.498-2.215,0.873-3.345,1.228c-1.115,0.351-2.241,0.682-3.39,0.948c-2.297,0.54-4.67,0.892-7.143,1 c-2.471,0.063-5.065-0.07-7.741-0.863c-2.652-0.739-5.466-2.274-7.577-4.683c-0.791-0.902-1.125-2.047-1.021-3.154l0.025-0.256 c0.263-2.715,0.687-5.373,1.29-7.954c0.606-2.574,1.319-5.103,2.161-7.567c0.831-2.468,1.769-4.885,2.792-7.26 c0.52-1.184,1.054-2.361,1.614-3.531c0.558-1.191,1.124-2.292,1.81-3.541c1.328-2.42,4.367-3.305,6.787-1.977 c2.343,1.286,3.247,4.175,2.097,6.554L153.785,190.712z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M161.587,217.351l3.987-4.49l6.548,5.985c0,0-4.454,4.948-9.174,2.35L161.587,217.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M172.121,211.134l2.625,2.75c0.915,0.958,0.774,2.503-0.299,3.28l-2.325,1.683l-6.548-5.985 l3.921-2.137C170.362,210.251,171.439,210.419,172.121,211.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M148.185,178.587c-6.036,3.688-12.02,23.208-12.02,23.208l15.805,5.807 c0,0,4.174-6.119,6.512-14.966C160.882,183.552,154.809,174.54,148.185,178.587z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M182.192,178.886c-0.131-0.033,0.18,0.015,0.329,0.025l0.608,0.048 c0.437,0.023,0.881,0.056,1.351,0.062c0.925,0.024,1.898,0.019,2.873-0.013c1.963-0.061,3.977-0.274,6.003-0.521 c1.014-0.126,2.031-0.281,3.05-0.467c1.022-0.142,2.043-0.374,3.068-0.561l3.072-0.677l3.077-0.766l-3.7,4.5 c0.298-1.688,0.431-3.541,0.372-5.468c-0.07-1.926-0.252-3.927-0.586-5.943c-0.315-2.021-0.745-4.065-1.249-6.111 c-0.489-2.028-1.107-4.146-1.686-6.07l-0.056-0.186c-0.476-1.583,0.422-3.253,2.006-3.729c1.264-0.38,2.586,0.12,3.308,1.142 c1.434,2.033,2.553,4.008,3.635,6.131c1.063,2.107,1.988,4.297,2.786,6.573c0.768,2.283,1.433,4.651,1.836,7.14 c0.404,2.487,0.607,5.098,0.389,7.822c-0.164,2.048-1.522,3.715-3.336,4.371l-0.364,0.13l-3.337,1.201 c-1.13,0.367-2.262,0.724-3.409,1.055c-2.3,0.648-4.626,1.244-7.025,1.654c-2.392,0.441-4.829,0.743-7.336,0.873 c-1.26,0.044-2.524,0.085-3.834,0.017c-0.648-0.024-1.32-0.071-1.997-0.136l-1.06-0.134c-0.405-0.062-0.648-0.091-1.328-0.233 c-3.239-0.701-5.296-3.895-4.595-7.134C175.76,180.242,178.954,178.185,182.192,178.886z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M197.73,156.732l-2.911-4.887l8.505-2.501c0,0,1.74,3.917,1,6.609 c-0.29,1.057-1.24,1.801-2.327,1.936l-1.52,0.188C199.376,158.213,198.298,157.686,197.73,156.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M196.9,144.07l2.35-0.269c1.467-0.168,2.833,0.77,3.205,2.199l0.869,3.345l-8.505,2.501 l-0.525-4.488C194.103,145.73,195.271,144.256,196.9,144.07z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M173.094,177.097c7.047,0.61,22.217-1.141,22.217-1.141l0.883,19.128c0,0-7.153,2.767-16.019,0.5 C171.072,193.255,165.36,176.428,173.094,177.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M161.403,158.375c0.816,5.455,1.426,15.41-2.52,18.846c2.807,3.054,6.882,7.013,13.292,7.529 c4.076-1.792,5.102-4.361,3.512-6.769c-5.964-1.712-5.606-6.179-4.366-10.332L161.403,158.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M165.446,162.159l5.87,5.485c-0.297,0.983-0.538,1.982-0.653,2.959 c-2.288-0.437-5.338-3.109-5.474-5.531C165.122,163.864,165.225,162.71,165.446,162.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M173.198,139.971c7.483,4.983,1.082,13.018,1.082,13.018S170.57,146.439,173.198,139.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M157.449,152.536c1.78,7.124,2.46,11.383,6.786,14.406c6.507,4.547,14.789-0.404,15.173-7.916 c0.346-6.761-2.623-17.275-10.209-18.833C161.726,138.659,155.669,145.413,157.449,152.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M169.261,152.229c0,0-1.885-0.16-2.977,0.978C168.005,153,169.261,152.229,169.261,152.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M169.447,152.954c0,0-1.712,0.215-2.392,1.532C168.529,153.947,169.447,152.954,169.447,152.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M169.647,157.595c-0.559-0.198-1.356-0.084-1.612,0.882 C168.574,157.995,169.175,157.704,169.647,157.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M173.886,144.616c0,0-4.325,0.422-7.633,1.514C170.544,145.424,173.886,144.616,173.886,144.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M175.172,145.115c0,0-5.824,1.199-8.385,2.612C171.872,146.425,175.172,145.115,175.172,145.115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M159.467,157.512c2.958-0.304,1.667-4.887,0.5-5.929c2.333-1.042,4.292-4.917,2.667-7.042 c8.625,0.667,13.554-0.25,14.215-8.042c-2.465,0.5-5.066-1.958-8.39,0.333c1.55-3.958-1.95-5.375-1.95-5.375 s-0.542,5.042-4.333,5.75c-3.792,0.708-7.792,3.417-8.042,6.208c-0.903-2.306-1.833-2.458-1.833-2.458s1.417,2.368,0,5.559 c-1.417,3.191,1,4.243,1,4.243s-3.097,0-1.153,4.184C153.539,157.939,158.8,161.692,159.467,157.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M155.513,159.234c0.993,1.572,2.619,2.54,4.115,2.853c2.25,0.471,3.224-1.579,2.471-3.623 c-0.677-1.84-2.664-4.302-4.861-3.854C155.073,155.052,154.378,157.436,155.513,159.234z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "124.147,390.082 108.937,385.261 110.377,380.717 127.473,384.526  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3
    },
    points: "124.147,390.082 108.937,385.261 110.377,380.717 127.473,384.526  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "170.267,398.744 155.34,398.978 155.265,394.155 171.234,393.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3
    },
    points: "170.267,398.744 155.34,398.978 155.265,394.155 171.234,393.64  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M169.871,152.308c0.088,0.59,0.472,1.022,0.858,0.965c0.386-0.057,0.627-0.582,0.54-1.173 c-0.088-0.59-0.472-1.022-0.858-0.965C170.025,151.193,169.783,151.718,169.871,152.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M176.543,151.315c0.088,0.59,0.472,1.022,0.858,0.965c0.386-0.057,0.627-0.583,0.539-1.173 c-0.088-0.59-0.472-1.022-0.858-0.965C176.696,150.2,176.455,150.725,176.543,151.315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A02724"
    },
    d: "M174.465,151.924c0,0,1.849,3.205,3.571,4.628c-0.899,1.13-2.741,0.949-2.741,0.949 L174.465,151.924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M173.133,159.772c-2.267,0.325-3.71-0.903-3.777-0.961c-0.073-0.063-0.08-0.174-0.017-0.247 c0.063-0.073,0.174-0.081,0.247-0.018c0.017,0.014,1.7,1.438,4.212,0.725c0.093-0.026,0.19,0.028,0.216,0.121 c0.026,0.093-0.028,0.19-0.121,0.216C173.631,159.684,173.378,159.737,173.133,159.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M166.31,150.76c-0.058,0.003-0.118-0.009-0.174-0.037c-0.173-0.087-0.243-0.297-0.157-0.47 c0.868-1.734,2.473-1.935,2.541-1.943c0.193-0.022,0.366,0.116,0.388,0.309c0.022,0.192-0.116,0.365-0.307,0.388l0,0 c-0.053,0.007-1.303,0.177-1.995,1.561C166.548,150.684,166.432,150.753,166.31,150.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M177.818,148.479c-0.113,0.006-0.227-0.044-0.3-0.142c-0.919-1.245-2.179-1.199-2.233-1.197 c-0.193,0.009-0.357-0.139-0.368-0.331c-0.01-0.193,0.136-0.357,0.329-0.368c0.07-0.003,1.685-0.079,2.836,1.48 c0.115,0.156,0.082,0.375-0.074,0.49C177.951,148.454,177.885,148.476,177.818,148.479z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M118.219,399.108c-0.619-0.291-1.227-0.733-1.639-1.064c-0.055-0.044-0.078-0.117-0.059-0.185 c0.019-0.068,0.077-0.118,0.148-0.126c0.315-0.038,3.099-0.35,3.661,0.378c0.087,0.113,0.169,0.305,0.061,0.576 c-0.144,0.365-0.387,0.595-0.722,0.684C119.246,399.484,118.729,399.347,118.219,399.108z M117.145,398.037 c1.03,0.762,1.924,1.131,2.435,0.996c0.224-0.06,0.383-0.215,0.486-0.474c0.05-0.127,0.02-0.191-0.013-0.233 C119.76,397.947,118.261,397.942,117.145,398.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M116.615,398.066c-0.03-0.014-0.056-0.037-0.074-0.066c-0.034-0.055-0.035-0.123-0.004-0.179 c0.045-0.079,1.112-1.936,2.189-2.206c0.28-0.07,0.54-0.032,0.771,0.113c0,0,0,0,0,0c0.357,0.225,0.347,0.506,0.309,0.653 c-0.209,0.813-2.238,1.651-3.107,1.702C116.67,398.084,116.641,398.078,116.615,398.066z M119.242,395.987 c-0.131-0.061-0.272-0.072-0.43-0.032c-0.69,0.173-1.433,1.199-1.776,1.727c0.935-0.2,2.309-0.907,2.432-1.388 c0.011-0.044,0.038-0.147-0.156-0.269l0,0C119.288,396.01,119.265,395.998,119.242,395.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M165.8,408.695c-0.062-0.02-0.108-0.074-0.118-0.139c-0.012-0.074,0.025-0.146,0.09-0.182 c0.333-0.179,3.284-1.733,4.19-1.246c0.175,0.094,0.278,0.254,0.297,0.462v0c0.032,0.349-0.074,0.637-0.315,0.857 c-0.8,0.731-2.925,0.473-4.12,0.254C165.815,408.699,165.807,408.697,165.8,408.695z M169.732,407.409 c-0.561-0.184-2.164,0.456-3.328,1.033c1.638,0.246,2.854,0.156,3.303-0.254c0.158-0.144,0.224-0.33,0.202-0.567 c-0.008-0.092-0.042-0.147-0.113-0.185C169.776,407.426,169.755,407.417,169.732,407.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M165.8,408.695c-0.016-0.005-0.031-0.013-0.045-0.022c-0.051-0.035-0.08-0.096-0.075-0.158 c0.007-0.085,0.175-2.08,1.104-2.867c0.283-0.24,0.609-0.346,0.967-0.316l0,0c0.482,0.041,0.625,0.283,0.66,0.479 c0.148,0.835-1.596,2.462-2.482,2.876C165.888,408.706,165.842,408.709,165.8,408.695z M167.9,405.714 c-0.046-0.015-0.104-0.027-0.18-0.033l0,0c-0.266-0.023-0.498,0.054-0.71,0.234c-0.61,0.517-0.855,1.713-0.941,2.296 c0.903-0.562,2.085-1.838,1.996-2.339C168.06,405.841,168.046,405.762,167.9,405.714z M167.736,405.506l0.004,0.001 L167.736,405.506z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M101.646,161.264c-1.13-11.599-0.586-22.288,1.615-31.771l0.974,0.226 c-2.176,9.377-2.712,19.958-1.593,31.449L101.646,161.264z M106.634,121.643l-0.938-0.346c0.943-2.556,2.039-5.008,3.259-7.289 l0.882,0.472C108.638,116.72,107.561,119.13,106.634,121.643z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M136.911,96.397c33.274-6.647,78.206,31.539,100.37,85.293 c22.152,53.757,13.15,102.717-20.113,109.362c-33.274,6.647-78.206-31.539-100.37-85.293S103.648,103.042,136.911,96.397z  M134.286,202.266c19.588,47.513,56.955,81.735,83.467,76.439c26.501-5.294,32.12-48.103,12.532-95.616 c-19.588-47.513-56.955-81.735-83.467-76.439C120.306,111.946,114.699,154.752,134.286,202.266z M107.6,176.399 c2.085-3.649,14.39-8.51,17.113-5.796 M231.678,270.67c3.132-0.378,6.215,7.163,4.125,9.952 M185.298,120.073 c2.098-0.573,3.942-3.462,4.196-5.154"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M209.454,292.298c-32.376,0.005-72.591-36.564-93.118-86.348 c-14.274-34.62-16.089-69.308-4.736-90.526c5.674-10.606,14.393-17.355,25.213-19.516l0,0 c33.44-6.682,78.716,31.717,100.93,85.593c14.27,34.629,16.082,69.32,4.729,90.534c-1.789,3.344-3.881,6.304-6.246,8.857 c-0.007,0.01-0.015,0.021-0.022,0.03l-0.003-0.003c-5.13,5.528-11.542,9.147-18.935,10.624 C214.727,292.05,212.114,292.298,209.454,292.298z M108.16,176.447c2.017,9.5,5.056,19.312,9.101,29.122 c22.041,53.456,66.814,91.577,99.81,84.994c7.173-1.434,13.4-4.947,18.387-10.315c1.046-1.528,0.41-4.688-0.804-6.787 c-0.842-1.458-1.858-2.304-2.751-2.304c-0.001,0-0.001,0-0.002,0c-3.821,4.207-8.58,6.945-14.05,8.038 c-26.687,5.343-64.384-29.093-84.027-76.738c-4.445-10.783-7.647-21.468-9.573-31.596c-0.642-0.518-1.933-0.674-3.668-0.44 C115.981,171.04,109.755,174.083,108.16,176.447z M134.748,202.075c19.47,47.227,56.663,81.389,82.907,76.139 c7.724-1.543,13.749-6.268,17.91-14.043c9.618-17.976,7.417-48.972-5.742-80.893c-19.47-47.226-56.658-81.379-82.907-76.139 c-7.727,1.543-13.754,6.269-17.915,14.044C119.385,139.156,121.588,170.151,134.748,202.075z M232.67,270.275 c1.018,0.314,2.018,1.244,2.85,2.685c0.929,1.607,1.557,3.734,1.459,5.545c1.707-2.078,3.249-4.397,4.612-6.942 c11.215-20.957,9.387-55.321-4.772-89.682c-11.272-27.338-28.494-50.67-47.041-66.059c-0.534,1.556-1.896,3.551-3.551,4.416 c17.093,13.755,33.597,36.161,44.521,62.659c13.271,32.19,15.455,63.513,5.699,81.745 C235.333,266.723,234.07,268.603,232.67,270.275z M137.009,96.888c-10.517,2.101-18.998,8.673-24.527,19.007 c-7.871,14.711-9.317,36.02-4.583,59.294c2.437-2.596,8.455-5.208,12.552-5.76c1.497-0.202,2.691-0.142,3.569,0.179 c-3.539-19.6-2.25-37.024,4.101-48.895c4.248-7.938,10.68-12.971,18.601-14.553c11.593-2.313,25.26,2.867,38.623,13.376 c1.678-0.584,3.229-2.903,3.598-4.401C171.464,100.889,152.874,93.715,137.009,96.888L137.009,96.888z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "182.083,153.245 213.245,150.028 212.507,144.372 181.563,149.252  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "199.565,146.413 200.212,151.373 213.241,150.026 212.504,144.374  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M201.891,151.08c0.066,0.51,0.525,0.877,1.037,0.829l36.157-3.341 c1.435-0.187,0.208-9.596-1.227-9.409l-35.805,6.04c-0.508,0.086-0.857,0.557-0.79,1.068L201.891,151.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M182.191,154.074L182.191,154.074c0.338-0.044,0.579-0.357,0.535-0.695l-0.576-4.421 c-0.044-0.338-0.357-0.579-0.695-0.535l0,0c-0.338,0.044-0.579,0.357-0.535,0.695l0.576,4.421 C181.54,153.877,181.853,154.118,182.191,154.074z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M312.613,305.212c0.526-0.906,1.919-0.563,1.946,0.485c0.064,2.488-0.251,5.992-2.021,9.041 c-3.153,5.431-9.729,7.36-9.729,7.36L312.613,305.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M304.51,333.81c0,0-8.411,0.478-15.451-5.013c-4.199-3.275-6.962-7.935-8.508-11.162 c-0.478-0.999,0.706-1.962,1.58-1.281L304.51,333.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M323.412,346.397c-5.789,8.525-16.798,10.916-16.798,10.916l19.258-28.361 c0.57-0.84,1.888-0.46,1.908,0.555C327.855,333.487,327.34,340.611,323.412,346.397z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M306.374,392.167c-0.021,0-0.043-0.001-0.064-0.005c-0.248-0.035-0.42-0.264-0.385-0.512 c3.024-21.242-2.483-77.902-8.928-91.86c-0.105-0.228-0.006-0.497,0.221-0.602c0.225-0.105,0.497-0.005,0.601,0.222 c6.489,14.05,12.041,71.024,9.002,92.368C306.79,392.004,306.596,392.167,306.374,392.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M293.823,367.024h25.102c1.322,0,2.363,1.127,2.259,2.445l-3.555,44.848 c-0.093,1.178-1.077,2.087-2.259,2.087h-17.992c-1.182,0-2.166-0.909-2.259-2.087l-3.555-44.848 C291.46,368.151,292.501,367.024,293.823,367.024z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M293.681,302.109c1.386,2.059,4.179,2.604,6.237,1.218c2.059-1.386,2.604-4.179,1.218-6.237 s-4.179-2.604-6.237-1.218C292.84,297.258,292.295,300.051,293.681,302.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M297.416,304.695c-1.641,0-3.253-0.788-4.236-2.249c-1.57-2.331-0.951-5.506,1.381-7.076 c2.332-1.568,5.507-0.951,7.076,1.382c1.57,2.331,0.951,5.506-1.381,7.076C299.385,304.415,298.396,304.695,297.416,304.695z  M297.403,295.71c-0.747,0-1.502,0.215-2.167,0.663c-1.779,1.197-2.252,3.62-1.054,5.399c1.197,1.778,3.62,2.252,5.399,1.053 c1.779-1.197,2.252-3.62,1.054-5.399C299.885,296.313,298.655,295.71,297.403,295.71z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M297.731,314.881c0.102,1.044,1.031,1.809,2.076,1.707c1.044-0.102,1.809-1.031,1.707-2.076 c-0.102-1.045-1.031-1.809-2.076-1.707C298.393,312.907,297.629,313.836,297.731,314.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M302.628,353.475c0.001,1.049,0.852,1.9,1.902,1.899s1.9-0.852,1.899-1.902s-0.852-1.9-1.902-1.899 C303.478,351.574,302.627,352.425,302.628,353.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M308.215,341.148c1.544-0.222,2.615-1.653,2.393-3.197c-0.222-1.544-1.653-2.615-3.197-2.393 c-1.544,0.222-2.615,1.653-2.393,3.197C305.24,340.298,306.671,341.37,308.215,341.148z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImageLight);
export default __webpack_public_path__ + "static/media/hero-image-light.6f2bf04efa64a26295013770ad062871.svg";
export { ForwardRef as ReactComponent };